import React from 'react';
import { LinkedinIcon, MailIcon, MapPinIcon, InstagramIcon } from 'lucide-react';
export function Footer() {
  return <footer className="bg-gradient-to-br from-purple-50 via-pink-50 to-white py-16 px-6 border-t border-purple-100" data-id="element-93">
      <div className="max-w-7xl mx-auto" data-id="element-94">
        <div className="grid md:grid-cols-3 gap-12 mb-12" data-id="element-95">
          <div data-id="element-96">
            <h3 className="text-2xl font-bold mb-4 text-slate-900" style={{
            fontFamily: 'Poppins, sans-serif'
          }} data-id="element-97">
              Enlaces Consultora
            </h3>
            <p className="text-slate-600 leading-relaxed" data-id="element-98">
              Especialistas en selección de personal y desarrollo de capital
              humano.
            </p>
          </div>

          <div data-id="element-99">
            <h4 className="font-semibold mb-4 text-slate-900" data-id="element-100">Contacto</h4>
            <div className="space-y-3 text-slate-600" data-id="element-101">
              <div className="flex items-start" data-id="element-102">
                <MapPinIcon className="w-5 h-5 mr-2 flex-shrink-0 mt-0.5 text-purple-700" data-id="element-103" />
                <span data-id="element-104">
                  Buenos Aires y Córdoba.
                  <br data-id="element-105" />
                  Cobertura Nacional
                </span>
              </div>
              <div className="flex items-center" data-id="element-106">
                <MailIcon className="w-5 h-5 mr-2 flex-shrink-0 text-purple-700" data-id="element-107" />
                <a href="mailto:info@enlacesconsultora.com" className="hover:text-purple-700 transition-colors" data-id="element-108">
                  info@enlacesconsultora.com
                </a>
              </div>
            </div>
          </div>

          <div data-id="element-109">
            <h4 className="font-semibold mb-4 text-slate-900" data-id="element-110">
              Seguinos en redes
            </h4>
            <div className="flex space-x-4" data-id="element-111">
              <a href="#" className="w-12 h-12 bg-purple-100 rounded-full flex items-center justify-center hover:bg-purple-700 hover:text-white transition-all duration-300" data-id="element-112">
                <LinkedinIcon className="w-5 h-5" data-id="element-113" />
              </a>
              <a href="#" className="w-12 h-12 bg-pink-100 rounded-full flex items-center justify-center hover:bg-pink-600 hover:text-white transition-all duration-300" data-id="element-114">
                <InstagramIcon className="w-5 h-5" data-id="element-115" />
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-purple-200 pt-8 flex flex-col md:flex-row justify-between items-center text-sm text-slate-500" data-id="element-116">
          <p data-id="element-117">
            Enlaces® es una marca registrada. Queda prohibida su reproducción
            total o parcial sin autorización previa.
          </p>
          <div className="flex space-x-6 mt-4 md:mt-0" data-id="element-118">
            <a href="#" className="hover:text-purple-700 transition-colors" data-id="element-119">
              Aviso de Privacidad
            </a>
            <a href="#" className="hover:text-purple-700 transition-colors" data-id="element-120">
              Política de Confidencialidad
            </a>
          </div>
        </div>
      </div>
    </footer>;
}